import App from "./App.svelte";
import { initializeEnvironment, getEnvironment } from "./config/env.js";
import { initializeLogger } from "./services/logging/log-handler.js";
import { initializeAgGrid } from "./services/ag-grid/config.js";

// Suppress ResizeObserver loop warnings - these are harmless and occur when resize
// observations can't be delivered in a single animation frame (common with splitpanes)
const resizeObserverErr = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    // Suppress this specific warning - it's not an error
    return true;
  }
  return resizeObserverErr ? resizeObserverErr(message, source, lineno, colno, error) : false;
};

async function initializeApp() {
  // Initialize AG Grid license first - must be done before any AG Grid code
  initializeAgGrid();

  // Initialize Environment
  await initializeEnvironment();
  const env = getEnvironment();

  // Initialize Application Insights and New Relic
  await initializeLogger();

  const app = new App({
    target: document.body,
    props: {},
  });

  return app;
}

export default initializeApp();
